import React from 'react';
import { Box, Text, VStack, Heading, Image, Container } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import resume from '../icons/resume.png';
import NavigationButtons from '../Components/NavigationButtons';

function ResumeResourcePage4() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/resume-resource-page-3');
  };

  const handleNext = () => {
    navigate('/resources');
  };

  return (
    <Box>
      {/* Header */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold">Resources</Text>
      </Box>

      {/* Main Content */}
      <Container bg="white" p={6} maxW="container.md" fontFamily="Raleway">
        <VStack spacing={6} align="stretch">
          <Heading size="lg" color="#00D29D" fontFamily="Raleway">
            Resume Breakdown
          </Heading>

          <Heading size="md" fontFamily="Raleway">Projects & Activities</Heading>

          <Text>
            The Projects and Activities section is your opportunity to highlight relevant work outside of formal employment.
            Include personal projects, class assignments, or extracurricular initiatives that demonstrate skills and impact.
            List each project or activity with a brief description and the tools or technologies used. 
            Focus on what you built, the problem it solved, or the value it brought.
          </Text>
          <Text>
            For activities, mention your role and the organization, along with any leadership positions or notable contributions.
            This section helps show well-roundedness and can be particularly helpful if you have limited work experience.
          </Text>

          {/* Image section */}
          <Box display="flex" alignItems="center" gap={4}>
            <Box flexShrink={0}>
              <Image 
                src={resume} 
                alt="Resume Icon"
                width="165px"
                height="134px"
              />
            </Box>
          </Box>

          <Heading size="lg" color="#00D29D" fontFamily="Raleway">
            Resume Breakdown
          </Heading>

          <Heading size="md" fontFamily="Raleway">Additional Information</Heading>
          <Text>
            The Additional Information section is where you can include important but less extensive details like Skills, Awards, 
            Certifications, Languages, or Interests. These elements give employers a quick sense of your broader capabilities.
          </Text>
          <Text>
            For skills, focus on technical tools, software, and languages relevant to your field. Separate them into categories 
            like "Programming Languages," "Tools & Frameworks," or "Design Tools" to improve readability.
          </Text>
          <Text>
            Awards and certifications should be listed with the awarding organization and date. If you're multilingual, include 
            language proficiencies. Hobbies and interests can be listed sparingly — only if they add personality or relevance 
            to the role you're applying for.
          </Text>

          {/* Closing message */}
          <Text fontWeight="semibold" fontStyle="italic" pt={4}>
            Thank you for taking the time to go through this resume walkthrough. We hope it was helpful and wish you the best of luck as you craft your standout resume!
          </Text>

          <NavigationButtons onNext={handleNext} onBack={handleBack} />
        </VStack>
      </Container>

      <Box marginTop="50px">
        <Navbar />
      </Box>
    </Box>
  );
}

export default ResumeResourcePage4;
